import type {IKuToolSDKInstance} from '../types/global';

export const slot: IKuToolSDKInstance['slot'] = {
    // 目前没有业务逻辑，设置为空函数即可，主要为了接口调用统计
    initDropMenuTool: () => {},
    initSideBarTool: () => {},
};
